export const parseCookies = () => {
    const cookiesArr = document.cookie.split("; ");
    return cookiesArr.reduce((acc, cur) => {
        const delimiter = cur.indexOf("=");
        const cookie = cur.slice(0, delimiter);
        const token = cur.slice(delimiter + 1);
        acc[cookie] = token;
        return acc;
    }, {});
};

export const getCookie = (cookie) => {
    const cookies = parseCookies();
    return cookies[cookie];
};
